import React from 'react';
import Grid from '@material-ui/core/Grid';
import TextInput from 'src/ui/library/TextInput';
import Autocomplete from 'src/ui/library/Autocomplete';
import DropdownNew from 'src/ui/library/DropdownNew';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import intl from 'react-intl-universal';
import ServiceTitlePres from './ServiceTitlePres';
import { SI_ADD_APPLICANT_VIEWS } from 'src/constants/constants';
import DatePicker from 'src/ui/library/DatePicker';
import PhoneInput from 'src/ui/library/PhoneInput';

export default function AddApplicantPres({
  contactNumber,
  changeEmployeeView,
  firstName,
  lastName,
  dateOfBirth,
  error,
  emailAddress,
  passportCountry,
  passportCountryList,
  relationshipStatus,
  relationshipStatusList,
  employee,
  employeeCode,
  setValue,
  addApplicantViewType,
  onEmployeeSelect,
  onSearch,
}) {
  const isSearchView = addApplicantViewType === SI_ADD_APPLICANT_VIEWS.SEARCH;
  const isAddNewView = addApplicantViewType === SI_ADD_APPLICANT_VIEWS.ADDNEW;

  return (
    <section className={'ssi-addapplicant'}>
      <ServiceTitlePres title={intl.get('serviceInit.addInit.applicant.title')} />

      {isSearchView && (
        <React.Fragment>
          <div className={'ssi-addapplicant-search'}>
            <Autocomplete
              label={intl.get('serviceInit.addInit.applicant.search')}
              valueKey="employeeName"
              labelKey="employeeName"
              defaultValue={employee && employee.employeeId ? employee : null}
              multi={false}
              hideIconOnSelect={true}
              styleType={'serviceInitiation'}
              noResultsText={intl.get('serviceInit.addInit.applicant.noResults')}
              onChange={val => onEmployeeSelect(val)}
              onFilter={(row, val) => {
                return row.employeeName.toLowerCase().indexOf(val.toLowerCase()) >= 0 ||
                  row.email.toLowerCase().indexOf(val.toLowerCase()) >= 0
                  ? true
                  : false;
              }}
              loadOptions={onSearch}
            />
          </div>
          <div className={'addlink-footer'}>
            <a onClick={changeEmployeeView.bind(null, 'open')}>+ {intl.get('serviceInit.addInit.applicant.addEmployee')}</a>
          </div>
        </React.Fragment>
      )}

      {isAddNewView && (
        <div className={'ssi-addapplicant-new'}>
          <a className={'ssi-nextreturn-section'} onClick={changeEmployeeView.bind(null, 'close')}>
            <ArrowBackIcon />
            <span>{intl.get('serviceInit.addInit.applicant.return')}</span>
          </a>

          <Grid container spacing={0} className={'ssi-addapplicant-container'}>
            {error && (
              <Grid item xs={12} className={'ssi-addapplicant-grid error'}>
                {intl.get('serviceInit.addInit.applicant.error')}: {error.message}
              </Grid>
            )}
            <Grid item xs={12} className={'ssi-addapplicant-grid'}>
              <TextInput
                className={'ssi-addapplicant-griditem'}
                label={intl.get('serviceInit.addInit.applicant.firstName')}
                required={true}
                value={firstName}
                onChange={event => setValue('firstName', event.target.value)}
                id="firstName"
              />
              <TextInput
                className={'ssi-addapplicant-griditem'}
                label={intl.get('serviceInit.addInit.applicant.lastName')}
                required={true}
                value={lastName}
                onChange={event => setValue('lastName', event.target.value)}
                id="lastName"
              />
              <TextInput
                className={'ssi-addapplicant-griditem'}
                label={intl.get('serviceInit.addInit.applicant.email')}
                required={true}
                value={emailAddress}
                onChange={event => setValue('emailAddress', event.target.value)}
                id="emailAddress"
              />
            </Grid>
            <Grid item xs={12} className={'ssi-addapplicant-grid'}>
              <DatePicker
                className={'ssi-addapplicant-griditem'}
                styleType={'serviceInitation'}
                value={dateOfBirth}
                required={true}
                from={1930}
                to={new Date().getFullYear()}
                id={`dateOfBirth`}
                name="dateOfBirth"
                label={intl.get('serviceInit.addInit.applicant.dateOfBirth')}
                format="YYYY-MM-DD"
                onChange={date => setValue('dateOfBirth', date)}
              />
              <DropdownNew
                id="passportCountry"
                name="passportCountry"
                label={intl.get('serviceInit.addInit.applicant.passportCountry')}
                options={
                  passportCountryList && passportCountryList.map((item, index) => ({ value: item.countryName, label: item.countryName }))
                }
                className={'ssi-addapplicant-griditem ssi-dropdown'}
                disableUnderline={true}
                required={true}
                value={passportCountry}
                onChange={event => setValue('passportCountry', event.target.value)}
              />

              <PhoneInput
                className={'ssi-addapplicant-griditem'}
                label={intl.get('serviceInit.addInit.applicant.contactNumber')}
                required={true}
                value={contactNumber}
                onChange={event => setValue('contactNumber', event.target.value)}
                id="contactNumber"
              />
            </Grid>
            <Grid item xs={12} className={'ssi-addapplicant-grid'}>
              <DropdownNew
                id="relationshipStatus"
                name="relationshipStatus"
                label={intl.get('serviceInit.addInit.applicant.relationshipStatus')}
                options={
                  relationshipStatusList && relationshipStatusList.map((item, index) => ({ value: item.status, label: item.status }))
                }
                className={'ssi-addapplicant-griditem ssi-dropdown'}
                disableUnderline={true}
                required={true}
                value={relationshipStatus}
                onChange={event => setValue('relationshipStatus', event.target.value)}
              />
              <TextInput
                className={'ssi-addapplicant-griditem'}
                label={intl.get('serviceInit.addInit.applicant.employeeCode')}
                required={true}
                value={employeeCode}
                onChange={event => setValue('employeeCode', event.target.value)}
                id="employeeCode"
              />
            </Grid>
          </Grid>
        </div>
      )}
    </section>
  );
}
